const { log } = require("./log");
const { events } = require("./events");

events.add(document.body, "click", () => {
  log("Hi!");
});


/*****************
 ** WEBPACK FOOTER
 ** ./js/index.js
 ** module id = 1
 ** module chunks = 0
 **/